module.exports = __webpack_public_path__ + "img/vertical_4_2_5012.6ceb6d0f.png";